import React, {Component} from 'react';
import {
    CommandBarButton,
    Dropdown,
    IDropdownOption,
    MessageBarType
} from "office-ui-fabric-react";
import {connect} from "react-redux";
import ApiService from "./ApiService";
import DispatchProps from "../utils/DispatchProps";
import School from "../models/School";
import Actions from "../redux/Actions";
import {IRootState} from "../store";
import {friendlySchoolName} from "../utils/Utils";

interface TriggerOption
{
    name: string;
    isPlaylist: boolean;
}

interface WorkloadTriggerControlsProps {
    workloadAndPlaylistOptions?: IDropdownOption[];
    apiService: ApiService;
    school: School;
    onWorkloadTriggered(): void;
}

interface WorkloadTriggerControlsState {
    selectedOption?: TriggerOption;
}

class WorkloadTriggerControls extends Component<WorkloadTriggerControlsProps & DispatchProps,WorkloadTriggerControlsState> {
    static displayName = WorkloadTriggerControls.name;

    constructor(props: WorkloadTriggerControlsProps & DispatchProps) {
        super(props);


        this.state = {
            selectedOption: undefined
        }
    }


    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<WorkloadTriggerControlsProps & DispatchProps>, prevState: WorkloadTriggerControlsState): Promise<void> {
        
    }
    
    private onOptionSelected = (event: any,option?: IDropdownOption) => {
        if(!option)
        {
            return;
        }
        
        this.setState({
            selectedOption: option.data
        });
    };
    
    private onStartClicked = async () => {

        if (!this.props.school || !this.state.selectedOption) {
            return;
        }
        
        try
        {
            if(this.state.selectedOption.isPlaylist)
            {
                await this.props.apiService.triggerPlaylist(this.props.school, this.state.selectedOption.name);
            }
            else
            {
                await this.props.apiService.triggerWorkload(this.props.school, this.state.selectedOption.name);
            }
            
            await this.props.dispatch(Actions.showMessageBar(`Started ${this.state.selectedOption.name} for ${friendlySchoolName(this.props.school)}`, MessageBarType.success));
            this.props.onWorkloadTriggered();

            this.setState({
                selectedOption: undefined
            });
        }
        catch (e)
        {
            console.log(e);
            await this.props.dispatch(Actions.showMessageBar(`Failed to start ${this.state.selectedOption.name} for ${friendlySchoolName(this.props.school)}`, MessageBarType.error));
        }
    };

    render(): JSX.Element
    {
        return (
            <div className={"flex-row flex--align-items-center"}>
                <Dropdown
                    className="workload-query-controls__input"
                    selectedKey={this.state.selectedOption ? this.state.selectedOption.name : null}
                    onChange={this.onOptionSelected}
                    placeholder={"Select Workload or Playlist"}
                    options={this.props.workloadAndPlaylistOptions ? this.props.workloadAndPlaylistOptions : []}
                    styles={{ dropdown: { width: 300 } }}
                />

                <CommandBarButton
                    iconProps={{iconName: "Rocket"}}
                    disabled={!this.state.selectedOption}
                    text={this.state.selectedOption?.isPlaylist ? "Start Playlist" : "Start Workload"}
                    onClick={this.onStartClicked}
                />
            </div>
        );
    }
}

export default connect((state: IRootState,ownProps: {school: School,workloadAndPlaylistOptions: IDropdownOption[],onWorkloadTriggered(): void}): WorkloadTriggerControlsProps => {

    return {
        school: ownProps.school,
        workloadAndPlaylistOptions: ownProps.workloadAndPlaylistOptions,
        apiService: state.auth.apiService,
        onWorkloadTriggered: ownProps.onWorkloadTriggered,
    };
})(WorkloadTriggerControls);